import { createServiceStore } from 'common/store';
import { INITIAL_STATE } from './constants';
export var useComplianceStore = createServiceStore({
    initialValues: INITIAL_STATE,
});
